module.exports = __webpack_public_path__ + "fonts/mx9Uck6uB63VIKFYnEMXrYX0hVgzZQUfRDuZrPvH3D8.woff2";